import { __rest } from "tslib";
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { PulseContext } from "./pulse-react.context.js";
const useLazyPulseSettings = ({ tag, name, updateSettingChange = false }) => {
    const { settings } = useContext(PulseContext);
    const [settingsData, setSettingsData] = useState(undefined);
    const [loading, setLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [error, setError] = useState();
    const unsubscribeRef = useRef(null);
    if (!settings) {
        throw new Error('Cannot use "settings" hook, please add "settings" to sdks array when initializing the Provider');
    }
    const get = useCallback(() => {
        setLoading(true);
        settings
            .getSettings({ tag, name, updateSettingChange })
            .then((result) => {
            if (updateSettingChange && result.subscribe) {
                unsubscribeRef.current = result.subscribe(setSettingsData, name);
                setSettingsData(result.value);
            }
            else {
                setSettingsData(result);
            }
            setLoading(false);
        })
            .catch((err) => {
            setHasError(true);
            setError(err);
            setLoading(false);
        });
    }, []);
    useEffect(() => {
        return () => {
            var _a;
            (_a = unsubscribeRef.current) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        };
    }, []);
    return { loading, settings: settingsData, hasError, error, get };
};
const usePulseSettings = (input) => {
    const _a = useLazyPulseSettings(input), { get } = _a, rest = __rest(_a, ["get"]);
    useEffect(() => {
        get();
    }, []);
    return Object.assign({}, rest);
};
export { useLazyPulseSettings, usePulseSettings };
//# sourceMappingURL=use-pulse-settings.hook.js.map